// extracted by mini-css-extract-plugin
export default {"modal":"turn-off-recording-confirmation-modal_modal__rrSXG"};